import { HotspotIcon, ShapeSettings, Size } from '@lessonup/pins-shared';
import { NumericRange } from '@lessonup/utils';

export const DEFAULT_SHAPE_LINE_JOIN = 'round';

/** Limit the stroke width to always fit inside the components layout */
export function clampStrokeWidth(strokeWidth: number, size: Size) {
  return Math.min(strokeWidth, size.width / 2, size.height / 2);
}

/**  The values of the strokeDashArray are relative to the strokeWidth, so that it visually remains consistent across different stroke widths */
export function scaleStrokeDashArray(strokeDashArray: string, strokeWidth: number) {
  return strokeDashArray
    .split(' ')
    .map((value) => {
      const parsedValue = parseFloat(value);
      return isNaN(parsedValue) ? value : parsedValue * strokeWidth;
    })
    .join(', ');
}

export function getShapeKey(shapeType: ShapeSettings['shapeType']) {
  switch (shapeType) {
    case 'RECTANGLE':
      return 'rectangle';
    case 'ELLIPSE':
      return 'ellipse';
    case 'TRIANGLE':
      return 'triangle';
    case 'POLYGON':
      return 'polygon';
    case 'STAR':
      return 'star';
    case 'ARROW':
      return 'arrow';
    case 'ICON':
      return 'icon';
    default:
      return 'SHAPE';
  }
}

// Polygon shapes defaults (Polygon and Star)
export const DEFAULT_POLYGON_POINTS = 5;
export const POLYGON_SHAPE_POINT_RANGE: NumericRange = {
  min: 3,
  max: 60,
};
export const DEFAULT_STAR_POINTS = 5;
export const DEFAULT_STAR_INNER_RADIUS = 38.2; // Golden ratio approximation, which is what the most common star shapes use

// Arrow shape defaults
export const DEFAULT_ARROW_HEAD_ANGLE = 90;
export const DEFAULT_ARROW_BODY_THICKNESS = 0.5;

// Icon shape defaults
export const DEFAULT_ICON_SHAPE: HotspotIcon = 'ROCKET';
